import React from "react";
import { Card, CardBody, Col, Container, Form, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { CustomFileUpload, LimitationFileUpload, SingleFileUpload } from "../../../Constant";
import CommonFileUpload from "../../Common/CommonFileUpload";
import HeaderCard from "../../Common/HeaderCard";
import Multipledropzone from "./Multipledropzone";

const DropzonesContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle="Dropzone" parent="Bonus Ui" title="Dropzone" />
      <Row>
        <Col sm="12">
          <Card>
            <HeaderCard title={SingleFileUpload} />
            <CardBody>
              <Form>
                <div className="dz-message needsclick">
                  <CommonFileUpload />
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
        <Multipledropzone />
        <Col sm="12">
          <Card>
            <HeaderCard title={LimitationFileUpload} />
            <CardBody>
              <Form>
                <div className="dz-message needsclick">
                  <CommonFileUpload />
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
        <Col sm="12">
          <Card>
            <HeaderCard title={CustomFileUpload} />
            <CardBody>
              <Form>
                <div className="dz-message needsclick">
                  <CommonFileUpload />
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
export default DropzonesContainer;
